export var NOTIFICATION_TYPE;
(function (NOTIFICATION_TYPE) {
    NOTIFICATION_TYPE["MAINTENANCE"] = "Maintenance";
    NOTIFICATION_TYPE["INCIDENTS"] = "Incidents";
    NOTIFICATION_TYPE["SITE_ALERTS"] = "Site Alerts";
})(NOTIFICATION_TYPE || (NOTIFICATION_TYPE = {}));
export var NOTIFICATION_ACTION_TYPE;
(function (NOTIFICATION_ACTION_TYPE) {
    NOTIFICATION_ACTION_TYPE["EDIT"] = "EDIT";
    NOTIFICATION_ACTION_TYPE["CLOSE"] = "CLOSE";
    NOTIFICATION_ACTION_TYPE["DELETE"] = "DELETE";
})(NOTIFICATION_ACTION_TYPE || (NOTIFICATION_ACTION_TYPE = {}));
export var SITE_ALERT_STATUS;
(function (SITE_ALERT_STATUS) {
    SITE_ALERT_STATUS["ACTIVE"] = "ACTIVE";
    SITE_ALERT_STATUS["UPCOMING"] = "UPCOMING";
    SITE_ALERT_STATUS["RESOLVED"] = "RESOLVED";
})(SITE_ALERT_STATUS || (SITE_ALERT_STATUS = {}));
//# sourceMappingURL=notifications.js.map